import useFeatureFlags from 'hooks/useFeatureFlags'
import type React from 'react'
import EMARResidentStockScreenV2 from '../ResidentEmarV2Screens/EMARResidentStockScreenV2/EMARResidentStockScreenV2'
import { EMARResidentStockScreen } from './EMARResidentStockScreen'

const EMARResidentStockScreenWrapper: React.FC = () => {
  const flags = useFeatureFlags({ flagNames: ['emar_v2_stock'] })?.data

  const newEmarEnabled = flags?.emar_v2_stock?.enabled ?? false

  if (newEmarEnabled) {
    return <EMARResidentStockScreenV2 />
  }

  return <EMARResidentStockScreen />
}

export default EMARResidentStockScreenWrapper
